<template>
  <BaseButton :is-icon-only="true" :is-circle="true" variant="outlines" @click="back">
    <template #left>
      <component :is="local === 'fa' ? IconArrowRight : IconArrowLeft" size="20"></component>
    </template>
  </BaseButton>
</template>



<script lang="ts" setup>
// import { defineEmits } from 'vue';
  import BaseButton from './BaseButton.vue';
  import { IconArrowRight,IconArrowLeft } from '@tabler/icons-vue';
  const { toggleLocale, locale: local } = useLocale()
  import { useLocale } from '@/composables/useLocale'


  const emits = defineEmits(['click-back'])

  const back = () => {
    emits('click-back')
  }
</script>
